import { HttpHeaders } from "@angular/common/http";

export const httpGetOptions = {
    headers: new HttpHeaders({
       
    })
  };
  export const httpJsonPostOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json',
        
    })
  };

  export const httpFormPostOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded'
        
    })
  };